import { useSelector } from 'react-redux';
import { getAllAccounts } from '../../store/accounts/selectors/accounts';
import { Account } from '../../../domain/accounts/Account';

const useOffBudgetAccounts = (): Account[] => {
	const accounts = useSelector(getAllAccounts);
	return Array.from(accounts.values()).filter(a => a.isOffBudget);
}

export default useOffBudgetAccounts;